/* eslint-disable no-magic-numbers */
import Graph, { IGraphItem } from "~/components/Graph";
import Page from "~/components/Page";

export default function TestPage() {
	const items: Array<IGraphItem> = [];

	items.push({
		label: "Hodnota 1",
		values: [1, 2, 3],
	});
	items.push({
		label: "Hodnota 2",
		values: [3, 2, 1],
	});
	items.push({
		label: "Hodnota 3",
		values: [1, 3, 2],
	});

	return <Page title={"Testovací stránka"} checkLogged={true} breadcrumbs={["Test"]} seoTitleTrans="seo.title.projects">
		<Graph title="Testovací graf" columns={["column1", "column2", "column3"]} items={items} />
	</Page>;
}
